import { QueryGetSummariesByPatientId, QuerySummariesResponse } from "@/api/dtos";
import { useGet } from "@ngt/opms";
import { useMemo } from "react";
import { SWRConfiguration, SWRResponse } from "swr";


const getData = (response?: SWRResponse<QuerySummariesResponse, QuerySummariesResponse>) => response?.data?.data; 

const getError = (response?: SWRResponse<QuerySummariesResponse, QuerySummariesResponse>) => (response?.error ?? response?.data)?.responseStatus;
// const getAdditionalState = (response?: SWRResponse<ContractGetCollectionByLotIdResponse, ContractGetCollectionByLotIdResponse>) => ({});

const useQuerySummariesByPatientId = (patientId?: number, configuration?: SWRConfiguration<QuerySummariesResponse, QuerySummariesResponse>) => {
    
    const request = useMemo(() => {
        if(!patientId) {
            return undefined;
        }

        return () => {
            return new QueryGetSummariesByPatientId({patientId: patientId});
        };
    }, [])

    return useGet(request, { getData, getError }, configuration);
}

export default useQuerySummariesByPatientId;